"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const AppButton_vue_1 = __importDefault(require("@/client/components/common/AppButton.vue"));
const vueUtils_1 = require("@/client/utils/vueUtils");
const PreferencesManager_1 = require("@/client/utils/PreferencesManager");
let unique = 0;
exports.default = (0, vue_1.defineComponent)({
    name: 'or-options',
    props: {
        playerView: {
            type: Object,
            required: true,
        },
        players: {
            type: Array,
            required: true,
        },
        playerinput: {
            type: Object,
            required: true,
        },
        onsave: {
            type: Function,
            required: true,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    components: {
        AppButton: AppButton_vue_1.default,
    },
    data() {
        const displayedOptions = [];
        const originalIndices = [];
        this.playerinput.options.forEach((option, i) => {
            if (option.type === 'card' && option.showOnlyInLearnerMode !== false && !(0, PreferencesManager_1.getPreferences)().learner_mode) {
                return;
            }
            displayedOptions.push(option);
            originalIndices.push(i);
        });
        const initialIdx = this.playerinput.initialIdx ?? 0;
        let selectedIdx = initialIdx;
        if (displayedOptions.length > 1 &&
            displayedOptions[initialIdx].type === 'card' &&
            !displayedOptions[initialIdx].cards.some((card) => card.isDisabled !== true)) {
            selectedIdx = initialIdx + 1;
        }
        return {
            displayedOptions,
            originalIndices,
            radioElementName: 'selectOption' + unique++,
            selectedOption: displayedOptions[selectedIdx],
            selectedIdx,
        };
    },
    watch: {
        selectedOption(newOption) {
            this.selectedIdx = this.displayedOptions.indexOf(newOption);
            const anchorTop = this.getSelectedOptionTop();
            this.$nextTick(() => {
                const newTop = this.getSelectedOptionTop();
                if (anchorTop !== undefined && newTop !== undefined) {
                    const delta = newTop - anchorTop;
                    if (Math.abs(delta) > 0.5) {
                        window.scrollBy(0, delta);
                    }
                }
            });
        },
    },
    methods: {
        getSelectedOptionTop() {
            const element = this.getSelectedOptionLabelElement();
            return element?.getBoundingClientRect().top;
        },
        getSelectedOptionLabelElement() {
            const idx = this.selectedIdx;
            const optionLabels = this.$refs.optionLabels;
            if (idx === -1 || !optionLabels) {
                return undefined;
            }
            const val = Array.isArray(optionLabels) ? optionLabels[idx] : optionLabels;
            return (0, vueUtils_1.isHTMLElement)(val) ? val : undefined;
        },
        playerFactorySaved(displayedIdx) {
            const idx = this.originalIndices[displayedIdx];
            return (out) => {
                this.onsave({
                    type: 'or',
                    index: idx,
                    response: out,
                });
            };
        },
        saveData() {
            let ref = this.$refs['inputfactory'];
            if (Array.isArray(ref)) {
                ref = ref[0];
            }
            ref.saveData();
        },
    },
});
